import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.VUE_APP_HAINAN_API || '',
  headers: {
    'Content-Type': 'application/json;',
  },
  timeout: 50000,
});

instance.interceptors.response.use((res) => res.data);

export default instance;
